module.exports = __webpack_public_path__ + "img/i-china.95b65c8d.svg";